module.exports = __webpack_public_path__ + "img/pr-23.6865ef79.png";